<template>
	<div style="height:100%;" align="Center" v-if="$store.getters.isInternalUser">
		<div id="overall-body">

			<!-- body start -->
			<div id="body-container" align="left">
				<table id="body-table" cellspacing="0" cellpadding="0">
					<tbody>
						<tr>

							<!-- MainBody Starts -->
							<td id="main-container">
								<!-- Main Content Starts -->
								<!--<h1></h1>-->

									<table width="100%" cellspacing="5" cellpadding="0" border="0">
										<tbody>
											<tr valign="top">

												<td valign="top" align="left">

													<div class="full-width">

														<table width="100%" cellspacing="0" cellpadding="0" border="0">
															<tbody>
																<tr>
																	<td colspan="2">
																		{{propertyData.propertyId}}
																	</td>
																</tr>
																<tr>
																	<td colspan="2">&nbsp;</td>
																</tr>
																<tr>
																	<td>
																		{{formattedDate(new Date)}}
																	</td>
																	<td style="text-transform: uppercase; font-size: 16px; font-weight: bold;">
																		Form 12a
																	</td>
																	<td>
																	</td>
																</tr>
																<tr>
																	<td colspan="2">&nbsp;</td>
																</tr>
																<tr>
																	<td>
																		{{supplier.companyName}}
																	</td>
																	<td>
																		<span class="compass-red">{{supplierMainContact.email}}</span>
																	</td>
																	<td>
																	</td>
																</tr>
																<tr>
																	<td colspan="2">
																		{{supplier.postalAddress}}
																	</td>
																</tr>
																<tr>
																	<td colspan="2">
																		{{supplier.city}}
																	</td>
																</tr>
															</tbody>
														</table>

														<br>

														<div style="margin: 10px 0;">
															<span style="text-transform: uppercase; font-weight: bold; font-size: 18px; letter-spacing: 1px;">Certificate of compliance with inspection,<br>maintenance and reporting procedures</span><br><span style="font-style: italic; font-weight: bold;">Section 108 (3)(c) Building Act 2004</span>
														</div>

														<br>

														<div style="margin: 10px 0;">
															<table width="100%" cellspacing="0" cellpadding="0" border="0">
																<tbody>
																	<tr>
																		<td colspan="2" class="title">The Building</td>
																	</tr>
																	<tr>
																		<td>Compliance Schedule No:</td>
																		<td>{{bwof.complianceSchedule}}</td>
																	</tr>
																	<tr>
																		<td>Warrant of Fitness Expiry Date:</td>
																		<td>{{formattedDate(service.whenNextServiceAnniversary)}}</td>
																	</tr>
																	<tr>
																		<td>Street Address of Building:</td>
																		<td>{{propertyData.streetAddress}} {{propertyData.suburb}} {{propertyData.city}}</td>
																	</tr>
																	<tr>
																		<td>Legal Description:</td>
																		<td>{{bwof.legalDescription}}</td>
																	</tr>
																	<tr>
																		<td>Building Name:</td>
																		<td>{{propertyData.buildingName}}</td>
																	</tr>
																	<tr>
																		<td>Location of Building within site/block number:</td>
																		<td>{{bwof.locationOfBuildingWithinSite}}</td>
																	</tr>
																	<tr>
																		<td>Level/Unit Number:</td>
																		<td>{{bwof.levelUnitNo}}</td>
																	</tr>
																	<tr>
																		<td colspan="2">&nbsp;</td>
																	</tr>
																	<tr>
																		<td colspan="2" class="title">The Owner</td>
																	</tr>
																	<tr>
																		<td>Name of Owner:</td>
																		<td>{{owner.companyName}}</td>
																	</tr>
																	<tr>
																		<td>Contact Person:</td>
																		<td>{{ownerContact.firstName}} {{ownerContact.lastName}}</td>
																	</tr>
																	<tr>
																		<td>Mailing Address:</td>
																		<td>{{owner.postalAddress}} {{owner.suburb}} {{owner.city}}</td>
																	</tr>
																	<tr>
																		<td>Street Address:</td>
																		<td>{{owner.streetAddress}}</td>
																	</tr>
																	<tr>
																		<td>Email Address:</td>
																		<td>{{ownerContact.email}}</td>
																	</tr>
																	<tr>
																		<td>Contact Number:</td>
																		<td>{{ ownerContact.ddi && ownerContact.ddi.trim() !== '' ? ownerContact.ddi : ownerContact.mobile }}</td>
																	</tr>
																</tbody>
															</table>
														</div>

														<br>

														<div style="margin: 10px 0; font-style: italic;">
															The inspection, maintenance and reporting procedures of the Compliance
															Schedule have been fully complied with during the 
															<span v-if="bwof.complianceScheduleMonths == 1">{{bwof.complianceScheduleMonths}} month</span><span v-else>{{bwof.complianceScheduleMonths}} months</span>
															 prior to the
															date stated below in relation to the following specified system/s
														</div>

														<div style="margin: 10px 0;">
															<table style="min-height: 150px; display: flex;">




																<tbody>

																	<!--for each specified system or feature-->
																	<template v-for="srv in visibleServices" v-bind:key="srv.serviceId">
																		<tr><td><span>{{srv.ref}}</span></td><td>{{srv.serviceName}}</td></tr>
																	</template>

																</tbody>
															</table>
														</div>

														<div style="margin: 10px 0;">
															<table class="signature" width="100%">
																<tbody>
																	<tr>
																		<td>Signed:</td>
																		<td>Name:</td>
																	</tr>
																	<tr>
																		<td>Date:</td>
																		<td>Position:</td>
																	</tr>
																	<tr>
																		<td colspan="2">IQP Registration No:</td>
																	</tr>
																</tbody>
															</table>
														</div>

													</div>

												</td>

											</tr>
										</tbody>
									</table>
							</td><!-- MainBody Ends -->

						</tr>
					</tbody>
				</table>
			</div>
			<!-- body end -->

		</div>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, CompanyData, ContactData, PropertyServiceData, PropertyBwofData } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';
	import { CompassApi } from '@/api-client/CompassApiProxy'
	import { Get12aPropertyServicesForSupplier } from '../../utils/CompassConstants';
	import Toast from '@/utils/Toast';

	@Options({
		name: 'CertificateOfComplianceTemplateExternal',
		props: {
			propertyData: null,
			service: null
		}
	})
	export default class CertificateOfComplianceTemplateExternal extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData();
		ownerContact: ContactData = new ContactData;
		service: PropertyServiceData = new PropertyServiceData;
		supplier: CompanyData | undefined = new CompanyData;
		supplierMainContact: ContactData = new ContactData;
		owner: CompanyData = new CompanyData;
		bwof: PropertyBwofData = new PropertyBwofData;

		created() {
			if (this.propertyData) {
				// Set Owner
				this.owner = this.propertyData.owner ? this.propertyData.owner : this.owner;

				// Set BWOF
				if (this.propertyData.propertyBwof)
					this.bwof = this.propertyData.propertyBwof;

				// Set Owner Contact from BWOF
				this.ownerContact = this.bwof.ownerContact != null ? this.bwof.ownerContact : this.ownerContact;
			}

			// Retrieve the supplier from the database
			if (this.service.supplierCompanyId) { 
				const apiClient = CompassApi.companyApi(this.$store);
				apiClient.getCompanyById(this.service.supplierCompanyId)
					.then(result => {
						this.supplier = result;

						// Get main contact from supplier
						if (this.supplier.contacts && this.supplier.contacts.length > 0) {
							this.supplierMainContact = this.supplier.contacts[0];
						}
					})
					.catch(error => {
						Toast.ApiError('Error retrieving company ' + this.service.supplierCompanyId, error);
					});
			}	
		}

		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'd MMMM yyyy');
		}

		// Gets all services from the same supplier and the Parent Service is BWOF
		get visibleServices() {
			let services: PropertyServiceData[] = [];

			// Get Services
			if (this.propertyData.services && this.propertyData.propertyId && this.service.supplierCompanyId) {
				services = Get12aPropertyServicesForSupplier(this.propertyData.services, this.propertyData.propertyId, this.service.supplierCompanyId);
			}

			return services;
		}
	}
</script>
<style scoped lang="scss">
	body, table td {
		font-size: 12px;
		line-height: 20px;
		font-family: arial, sans serif;
	}

	.title {
		text-decoration: underline;
		font-size: 14px;
		text-transform: uppercase;
	}

	.full-width {
		width: 750px;
	}

	@media print {
		.full-width {
			width: 100%;
		}

		div#overall-body {
			width: 100%;
			background-color: white;
		}
	}

	.signature td {
		font-weight: bold;
		border-bottom: 1px solid black;
	}
</style>